export default class IasAdapter {
  constructor(tech) {
    this._tech = tech;
  }

  tech() {
    return this._tech;
  }

  setup(adsManager) {
    if(window.googleImaVansAdapter && window.googleImaVansAdapter.init && window.iasConfig) {
      window.googleImaVansAdapter.init(window.google, adsManager, this.tech().el().el(), window.iasConfig);
    }
  }
}